<tabs-inner-wrap>
  <overall-scoring-section></overall-scoring-section>
  <messaging-section *ngIf="!messagingDisabled"></messaging-section>
  <methodology-section *ngIf="!methodolgyDisabled"></methodology-section>
  <skill-section *ngIf="!skillsDisabled"></skill-section>
</tabs-inner-wrap>
